// extracted by mini-css-extract-plugin
module.exports = {"StripeElement":"_5D3dS4_h","StripeElement--focus":"_5D3e8JcC","StripeElement--invalid":"_5D2wr6K1","StripeElement--webkit-autofill":"_5D2mKpUW"};